// To be used for 'syncing' with tailwind values
// documented here https://tailwindcss.com/docs/responsive-design#overview

export const tailwindBreakpointOverrides = {
  values: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1536,
  },
};
